import { useBuild } from "app/components/build/Show/lib/BuildContext";
import V2TestEngine from "app/components/build/Show/V2TestEngine";

export default function Tests() {
  const { build } = useBuild();

  if (!build) {
    throw new Error("Missing build context");
  }

  return <V2TestEngine build={build} />;
}
